import React from 'react'

import { ProductCarouselContainer, ProductCarouselContainerProps } from './ProductCarouselContainer'
import { ProductCarouselImageSlide, ProductCarouselImageSlideProps } from './ProductCarouselImageSlide'
import { ProductCarouselImageSlider, ProductCarouselImageSliderProps } from './ProductCarouselImageSlider'
import { ProductCarouselThumbList, ProductCarouselThumbListProps } from './ProductCarouselThumbList'
import { ProductCarouselThumbnail, ProductCarouselThumbnailProps } from './ProductCarouselThumbnail'

export type ProductCarouselProps =
  | ({
    wrapper: true;
    imagelist?: false;
    slider?: false;
    slide?: false;
    thumb?: false;
  } & ProductCarouselContainerProps)
  | ({
    wrapper?: false;
    imagelist: true;
    slider?: false;
    slide?: false;
    thumb?: false;
  } & ProductCarouselThumbListProps)
  | ({
    wrapper?: false;
    imagelist?: false;
    slider: true;
    slide?: false;
    thumb?: false;
  } & ProductCarouselImageSliderProps)
  | ({
    wrapper?: false;
    imagelist?: false;
    slider?: false;
    slide: true;
    thumb?: false;
  } & ProductCarouselImageSlideProps)
  | ({
    wrapper?: false;
    imagelist?: false;
    slider?: false;
    slide?: false;
    thumb?: true;
  } & ProductCarouselThumbnailProps)

export const ProductCarousel: React.FC<ProductCarouselProps> = ({ wrapper, imagelist, slider, slide, thumb, ...props }) => {
  if (thumb) {
    return <ProductCarouselThumbnail {...(props as ProductCarouselThumbnailProps)} />
  }

  if (slide) {
    return <ProductCarouselImageSlide {...(props as ProductCarouselImageSlideProps)} />
  }

  if (imagelist) {
    return <ProductCarouselThumbList {...(props as ProductCarouselThumbListProps)} />
  }

  if (slider) {
    return <ProductCarouselImageSlider {...(props as ProductCarouselImageSliderProps)} />
  }

  return <ProductCarouselContainer {...(props as ProductCarouselContainerProps)} />
}
